module.exports = __webpack_public_path__ + "img/r_phone_h.7407e329.png";